import { render, staticRenderFns } from "./DetailsBlock.vue?vue&type=template&id=2282f789&scoped=true"
import script from "./DetailsBlock.vue?vue&type=script&lang=js"
export * from "./DetailsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2282f789",
  null
  
)

export default component.exports